/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import PageType from 'linced-app/enums/page-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import moment from 'moment';
import { service } from '@ember/service';

export default class ContentRoute extends Route {
  // Services
  @service
  dates;

  @service
  store;

  model() {
    let group = this.modelFor('group');
    let startTime = moment(this.dates.rolloverDate).format('X'); // School rollover date, formatted as unix timestamp.
    return hash({
      group,
      learners: this.modelFor('group.insights').learners,
      pages: this.store
        .query('posts/page', { type: PageType.STUDENT, visibleInMenu: true })
        .then((pages) => {
          return pages.filter((page) => page.hasPosts);
        }),
      postMeta: this.store.query('posts/post', {
        groupId: group.id,
        startTime,
        metaOnly: true,
        include: 'tags',
      }),
      staff: this.store.query('person', { type: PersonType.STAFF }),
      tagCategories: this.store.findAll('posts/tag-category'),
    });
  }
}
